import { render, staticRenderFns } from "./FamCardView.vue?vue&type=template&id=4883b593&scoped=true&lang=pug"
import script from "./FamCardView.vue?vue&type=script&lang=js"
export * from "./FamCardView.vue?vue&type=script&lang=js"
import style0 from "./FamCardView.vue?vue&type=style&index=0&id=4883b593&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4883b593",
  null
  
)

export default component.exports